module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n    \n    Her kan du angive hvilke tidsregistreringstyper, der IKKE skal tælle med i eksempelvis udregningen af medarbejdernes tid hos kunderne.\n    "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n            Tidsregistreringstyper (" + _vm._s(_vm.rows.length > 0 ? _vm.rows.length : '') + ")\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "searchOptions": _vm.searchOptions,
      "paginationOptions": _vm.paginationOptions,
      "sortOptions": _vm.sortOptions,
      "styleClass": "vgt-table"
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'hours_last_year') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("number")(props.row.hours_last_year)) + "\n                    ")]) : (props.column.field == 'action') ? _c('div', [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (props.row.used_for_calculation),
            expression: "props.row.used_for_calculation"
          }],
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "checked": Array.isArray(props.row.used_for_calculation) ? _vm._i(props.row.used_for_calculation, null) > -1 : (props.row.used_for_calculation)
          },
          on: {
            "change": [function($event) {
              var $$a = props.row.used_for_calculation,
                $$el = $event.target,
                $$c = $$el.checked ? (true) : (false);
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.$set(props.row, "used_for_calculation", $$a.concat([$$v])))
                } else {
                  $$i > -1 && (_vm.$set(props.row, "used_for_calculation", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
                }
              } else {
                _vm.$set(props.row, "used_for_calculation", $$c)
              }
            }, function($event) {
              return _vm.update(props.row)
            }]
          }
        }), _vm._v("\n                         \n                        "), (props.row.used_for_calculation) ? _c('span', [_vm._v("\n                            Synlig\n                        ")]) : _c('span', [_vm._v("\n                            Skjult\n                        ")])]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                        " + _vm._s(props.formattedRow[props.column.field]) + "\n                    ")])]
      }
    }], null, false, 1880780003)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                    Ingen data ...\n                ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68993e6c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/settings/components/timeloggingTypesSettings.vue
// module id = 888
// module chunks = 0